import React from "react";

import { Form as FormikForm, useFormikContext } from "formik";

import { Button } from "clearsense-ui/components";
import PermissibleWrapper from "components/Common/PermissibleWrapper";

import Fields from "./Fields";

import { generateFields } from "../../utils";

const Form = ({ activeTab, subTab, isViewMode, userPermissions }) => {
  const formik = useFormikContext();

  return (
    <FormikForm>
      <div className="bg-white p-10 rounded w-full space-y-3">
        <Fields
          fields={generateFields(subTab)[activeTab]}
          isViewMode={isViewMode}
        />
      </div>
      <PermissibleWrapper
        currentPermissions={userPermissions}
        acceptablePermissions="update"
      >
        {!isViewMode && (
          <Button
            type="submit"
            label="Save"
            size="large"
            className="float-right mt-8"
            disabled={!formik.dirty}
            loading={formik.isSubmitting}
          />
        )}
      </PermissibleWrapper>
    </FormikForm>
  );
};

export default Form;
